import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { Card, Grid, Divider, Button } from "@material-ui/core";
import { BarChart } from "@material-ui/icons";

import { apiCall } from "../../utils/api";
import { API_URLS } from "../../constants/api";
import StudentProjectTable from "../../containers/StudentProject/StudentProjectTable";
import StudentProjectButton from "../../containers/StudentProject/StudentProjectButton";
import StudentProjectStatistics from "../../containers/StudentProject/StudentProjectStatistics";
import { useContentHeight } from "../../utils/useContentHeight";
import { getCurrentSchoolYear } from "containers/User/TimeResearch/utils";

function StudentProject(props) {
  const [filterObj, setFilterObj] = useState(null);
  const [yearlyValue, setYearlyValue] = useState(null);
  const [year, setYear] = useState(getCurrentSchoolYear());
  const [chosenDepartmentId, setChosenDepartmentId] = useState(0);
  // Refactor 2026-05-21: reloadKey bump để Table refetch dueDate khi user click
  // nút Reload trong Button. Trước đó Replay chỉ dispatch filter list →
  // deadline cell (đọc YearlyDueDate qua useDueDate) không refresh → stale.
  const [reloadKey, setReloadKey] = useState(0);
  const bumpReload = () => setReloadKey((k) => k + 1);

  // Chiều cao vùng nội dung, tự trừ header + footer (footer cao 60px khi ≤960px).
  const contentHeight = useContentHeight();
  // Tên đề tài thường là cột dài nhất và hay bị xuống dòng → mặc định ẩn
  // panel thống kê để bảng có tối đa chiều rộng ngay từ đầu; người dùng bật
  // lại khi cần qua nút Hiện thống kê.
  const [showStats, setShowStats] = useState(false);

  const now = new Date();
  const isRegister = new Date(yearlyValue?.regStartTime) <= now && now <= new Date(yearlyValue?.regEndTime);
  const isReport = new Date(yearlyValue?.reportStartTime) <= now && now <= new Date(yearlyValue?.reportEndTime);
  const isAccept = new Date(yearlyValue?.acceptStartTime) <= now && now <= new Date(yearlyValue?.acceptEndTime);

  const getData = async () => {
    const api = API_URLS.YEARLY_DUE_DATE.filterYearlyDueDate();
    const { response, error } = await apiCall({
      ...api,
      payload: { type: "student", schoolYear: year },
    });
    if (!error && response.status === 200 && response.data.success) {
      if (response.data.data.length > 0) {
        const res = response.data.data[0];
        setYearlyValue({
          ...res,
          regStartTimeString: dayjs(res.regStartTime).format("DD/MM/YYYY"),
          reportStartTimeString: dayjs(res.reportStartTime).format("DD/MM/YYYY"),
          acceptStartTimeString: dayjs(res.acceptStartTime).format("DD/MM/YYYY"),
          regEndTimeString: dayjs(res.regEndTime).format("DD/MM/YYYY"),
          reportEndTimeString: dayjs(res.reportEndTime).format("DD/MM/YYYY"),
          acceptEndTimeString: dayjs(res.acceptEndTime).format("DD/MM/YYYY"),
        });
      }
    }
  };

  useEffect(() => getData(), []);

  return (
    // Layout 2026-09-11: Card là flex COLUMN cao đúng CONTENT_HEIGHT; khối điều
    // khiển giữ chiều cao tự nhiên, vùng bảng `flex: 1` chiếm phần còn lại.
    // Trước đây Card cao calc(100vh - 108px) còn Grid item chứa bảng lại đặt
    // height:100% — cộng thêm 3 hàng phía trên nên tràn khỏi Card, phần paging
    // tụt xuống dưới và bị footer (position: fixed) che.
    <Card
      style={{
        padding: "8px 16px",
        height: contentHeight,
        maxHeight: contentHeight,
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
      <Grid container spacing={1} style={{ flexShrink: 0 }}>
        <StudentProjectButton
          year={year}
          setYear={setYear}
          type={props.type}
          setFilterObj={setFilterObj}
          chosenDepartmentId={chosenDepartmentId}
          setChosenDepartmentId={setChosenDepartmentId}
          bumpReload={bumpReload}
        />
        <Grid item xs={12} style={{ display: "flex", alignItems: "center", justifyContent: "flex-end" }}>
          <Button
            size="small"
            variant="outlined"
            startIcon={<BarChart />}
            onClick={() => setShowStats(!showStats)}
          >
            {showStats ? "Ẩn thống kê" : "Hiện thống kê"}
          </Button>
        </Grid>
        <Grid item xs={12}>
          <Divider />
        </Grid>
      </Grid>

      {/* Vùng bảng — chiếm toàn bộ chiều cao còn lại. `minHeight: 0` là bắt
          buộc: không có nó, flex item không co được dưới kích thước nội dung
          nên vùng scroll vẫn tràn ra ngoài. */}
      <Grid container spacing={1} style={{ flex: 1, minHeight: 0 }}>
        <Grid item xs={12} md={showStats ? 10 : 12} style={{ height: "100%" }}>
          <StudentProjectTable
            year={year}
            type={props.type}
            filterObj={filterObj}
            isRegister={isRegister}
            isReport={isReport}
            isAccept={isAccept}
            chosenDepartmentId={chosenDepartmentId}
            reloadKey={reloadKey}
          />
        </Grid>
        {showStats && (
          <Grid item xs={12} md={2} style={{ height: "100%", overflow: "auto" }}>
            <StudentProjectStatistics />
          </Grid>
        )}
      </Grid>
    </Card>
  );
}

export default StudentProject;

